import React from 'react';

import { Image } from '../../Image/Image';
import styles from './NavImage.scss';
import classNames from 'classnames';
import { NavigationItemType } from '../itemTypes';
import { formatTestId } from '../../../../utils/test-id/format-testid';

type NavImageProps = {
  asAnchor?: boolean;
  label: string;
  url?: string;
  handleClick?: () => void;
  imageUrl: string;
  itemType: NavigationItemType;
  tabIndex?: number;
};

export const NavImage = ({
  asAnchor,
  label,
  url,
  handleClick,
  imageUrl,
  itemType,
  tabIndex,
}: NavImageProps) => {
  const Wrapper = asAnchor ? 'a' : 'button';

  let width;
  let height;

  /* these are the width and height values going to the image API 
     - not the displayed dimensions
     they will be multiplied up based on pixel density */

  switch (itemType) {
    case NavigationItemType.BRAND_LOGOS:
      width = 204;
      height = 79;
      break;
    case NavigationItemType.IMAGE_GRID:
      width = height = 204;
      break;
    case NavigationItemType.WALL_LARGE:
      width = 273;
      height = Math.floor(width * 1.333);
      break;
    case NavigationItemType.WALL_SMALL:
      width = 135;
      height = Math.floor(width * 1.333);
      break;
    default:
      width = height = 150;
  }

  const showText = itemType !== NavigationItemType.BRAND_LOGOS;

  return (
    <Wrapper
      onClick={handleClick}
      href={asAnchor ? url : undefined}
      tabIndex={tabIndex}
      data-testid={formatTestId(label, 'nav-')}
      className={classNames(styles.wrapper, styles[itemType])}
      aria-label={
        label.endsWith('*')
          ? `${label.replace('*', '')} selected lines only`
          : label
      }
    >
      <Image url={imageUrl} label={label} width={width} height={height} />
      {showText && (
        <div className={styles.overlay}>
          <span>{label}</span>
        </div>
      )}
    </Wrapper>
  );
};
